import { render } from "./HeroSection.vue?vue&type=template&id=61f08a6e&scoped=true"
const script = {}

import "./HeroSection.vue?vue&type=style&index=0&id=61f08a6e&scoped=true&lang=css"

import exportComponent from "/home/armin/w/euro-petrol-website/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-61f08a6e"]])

export default __exports__